import { AccountObject, IAccountObjectArgs } from "../account-object/account-object.model";

export interface ICategoryArgs extends IAccountObjectArgs {
    title?: string;
    sequence?: number;
}

const defaults = {
    title: "",
    sequence: 0
} as ICategoryArgs;

export abstract class Category extends AccountObject {
    title: string;
    sequence: number;

    constructor(data?: ICategoryArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/category/category.model.ts